module.exports = __webpack_public_path__ + "media/7_1.18b7b48d.mp4";